module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-container"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v(" In All Matches")])]), _vm._v(" "), _vm._l((_vm.totals), function(item, key) {
    return (_vm.allMatchAttrs.indexOf(key) > -1) ? _c('div', {
      staticClass: "summary-data"
    }, [_c('span', [_vm._v(_vm._s(key.toUpperCase().replace(/_/g, ' ')))]), _vm._v(" "), _c('span', {
      staticClass: "success"
    }, [_vm._v(_vm._s(item))])]) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_c('i', {
    staticClass: "el-icon-caret-right"
  }), _vm._v(" In Parsed Matches")])]), _vm._v(" "), _vm._l((_vm.totals), function(item, key) {
    return (_vm.parsedMatchAttrs.indexOf(key) > -1) ? _c('div', {
      staticClass: "summary-data"
    }, [_c('span', [_vm._v(_vm._s(key.toUpperCase().replace(/_/g, ' ')))]), _vm._v(" "), _c('span', {
      staticClass: "success"
    }, [_vm._v(_vm._s(item))])]) : _vm._e()
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3536d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Totals.vue
// module id = 137
// module chunks = 1